var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayPayments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_27248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_27248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25033 28.3337C3.47116 28.3337 2.80414 28.0562 2.24928 27.5014C1.69442 26.9465 1.41699 26.2795 1.41699 25.5003V9.91699H4.25033V25.5003H28.3337V28.3337H4.25033ZM9.91699 22.667C9.13783 22.667 8.47081 22.3896 7.91595 21.8347C7.36109 21.2798 7.08366 20.6128 7.08366 19.8337V8.50033C7.08366 7.72116 7.36109 7.05414 7.91595 6.49928C8.47081 5.94442 9.13783 5.66699 9.91699 5.66699H29.7503C30.5295 5.66699 31.1965 5.94442 31.7514 6.49928C32.3062 7.05414 32.5837 7.72116 32.5837 8.50033V19.8337C32.5837 20.6128 32.3062 21.2798 31.7514 21.8347C31.1965 22.3896 30.5295 22.667 29.7503 22.667H9.91699ZM12.7503 19.8337C12.7503 19.0545 12.4729 18.3875 11.918 17.8326C11.3632 17.2778 10.6962 17.0003 9.91699 17.0003V19.8337H12.7503ZM26.917 19.8337H29.7503V17.0003C28.9712 17.0003 28.3041 17.2778 27.7493 17.8326C27.1944 18.3875 26.917 19.0545 26.917 19.8337ZM19.8337 18.417C21.0142 18.417 22.0177 18.0038 22.8441 17.1774C23.6705 16.351 24.0837 15.3475 24.0837 14.167C24.0837 12.9864 23.6705 11.983 22.8441 11.1566C22.0177 10.3302 21.0142 9.91699 19.8337 9.91699C18.6531 9.91699 17.6496 10.3302 16.8232 11.1566C15.9969 11.983 15.5837 12.9864 15.5837 14.167C15.5837 15.3475 15.9969 16.351 16.8232 17.1774C17.6496 18.0038 18.6531 18.417 19.8337 18.417ZM9.91699 11.3337C10.6962 11.3337 11.3632 11.0562 11.918 10.5014C12.4729 9.94651 12.7503 9.27949 12.7503 8.50033H9.91699V11.3337ZM29.7503 11.3337V8.50033H26.917C26.917 9.27949 27.1944 9.94651 27.7493 10.5014C28.3041 11.0562 28.9712 11.3337 29.7503 11.3337Z",
    fill: "#71717A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPayments);
export default __webpack_public_path__ + "static/media/gray_payments.25b9b4c23a21036aaf9731a20e32fe98.svg";
export { ForwardRef as ReactComponent };